import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Contact from "../views/Contact.vue";

import Search from "../views/Search.vue";
import Theme from "../views/Theme.vue";
import Occasion from "../views/Occasion.vue";

import ProductPage from "../views/ProductPage.vue";
import Cart from "../views/Cart.vue";
import Checkout from "../views/Checkout.vue";
import OrderRecieved from "../views/OrderRecieved.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home
    }, {
        path: "/contact",
        name: "Contact",
        component: Contact
    },
    {
        path: "/search/:category?",
        name: "Search",
        component: Search,
    },
    {
        path: "/theme/:theme",
        name: "Theme",
        component: Theme
    },
    {
        path: "/occasion/:occasion",
        name: "Occasion",
        component: Occasion
    },
    {
        path: "/about",
        name: "About",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/About.vue"),
    },
    {
        path: "/product/:id",
        name: "Product",
        component: ProductPage,
    },
    {
        path: "/cart",
        name: "Cart",
        component: Cart,
    },
    {
        path: "/checkout",
        name: "Checkout",
        component: Checkout
    },
    {
        path: "/order-recieved/:id",
        name: "OrderRecieved",
        component: OrderRecieved
    }
];

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior() {
        // console.log(to);
        // console.log(from);
        // if (savedPosition) {
        //     console.log(savedPosition);
        //     return savedPosition;
        // }
        return { x: 0, y: 0 };
    },
});

export default router;
